<template>
  <div id="noticeboard">
    <User v-if="components.user" @close="components.user = false" />
    <div class="nav">
      <div class="left">
        <div class="img" :style="$bgd(user.gravatar)" @click="components.user = true" />
        <span v-if="!isShowMyClasses" class="text-button" @click="isShowArea = true">
          <i class="anyteachicon anyteach-location-arrow" />
          {{ areas[selectedArea] }}
        </span>
        <!-- <router-link v-if="!isShowMyClasses" tag="span" to="/homeclass/faq" class="text-button">
          <i style="transform: none" class="anyteachicon anyteach-question-circle"></i>
        </router-link>-->
      </div>
      <div class="right">
        <span class="padded-button" :class="{ selected: isShowMyClasses }" @click="tab()"
          >我的拼课</span
        >
        <span class="padded-button red-bgd" @click="postClass()">
          <i class="anyteachicon anyteach-plus" />发起
        </span>
      </div>
    </div>
    <router-link tag="div" to="/homeclass/faq" class="faq-link">了解同城拼课</router-link>
    <div class="content-wrapper">
      <div v-if="!isShowMyClasses" id="homeclass-list">
        <div v-if="homeclass[0]" class="noticeboard">
          <div v-for="item in homeclass" :key="item.id">
            <Item
              v-if="item.homeclassType == 2 && (item.area_id == selectedArea || selectedArea == 0)"
              :data="item"
            />
          </div>
          <div v-for="item in homeclass" :key="item.h_id">
            <Item
              v-if="item.homeclassType == 1 && (item.area == selectedArea || selectedArea == 0)"
              :is-promo-availability="isPromoAvailability"
              :promo="promo"
              :data="item"
            />
          </div>
          <div
            v-if="selectedArea > 0 && homeclass.every(item => item.area != selectedArea)"
            class="empty"
          >
            <div class="text-container">
              <h1>当前城市暂无课程</h1>
              <h2>
                您可以
                <span @click="postClass()">发起拼课</span>，邀请首单用户学费立减 10%。
              </h2>
            </div>
          </div>
        </div>
        <div v-else-if="noHomeclass == 0 && !homeclass[0]" class="empty">
          <inline-loading />
        </div>
        <div v-else-if="noHomeclass == 2" class="empty">
          <div class="text-container">
            <h1>暂无课程</h1>
            <h2>
              您可以
              <span @click="postClass()">发起拼课</span>，邀请首单用户学费立减 10%。
            </h2>
          </div>
        </div>
      </div>
      <div v-if="isShowMyClasses" id="homeclass-my">
        <div v-if="myHomeclass[0]">
          <Item v-for="item in myHomeclass" :key="item.id || item.h_id" :data="item" />
        </div>
        <div v-if="!myHomeclass[0] && noMyHomeclass != 3" class="empty">
          <inline-loading />
        </div>
        <div v-if="noMyHomeclass == 3" class="empty">
          <div class="text-container">
            <h1>没有课程</h1>
            <h2>
              您可以
              <span @click="postClass()">发起拼课</span>，邀请首单用户学费立减 10%。
            </h2>
          </div>
        </div>
      </div>
    </div>
    <footerBox />
    <SelectArea v-if="isShowArea" :area_id="selectedArea" @close="onChangeArea($event)" />
  </div>
</template>
<style scoped type="text/css" lang="scss">
@import "../../../static/css/homeclass.scss";

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 3%;
  background: white;
  z-index: 10;

  transition: all 0.2s;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  .left,
  .right {
    .padded-button {
      padding: 6px 8px;
    }
    .text-button,
    .padded-button {
      font-size: 13px;
      font-weight: 500;
      border-radius: 20px;
      background: white;
      color: $black;
      transition: all 0.2s;
      border: 1px solid rgba(0, 0, 0, 0);
      &:active {
        opacity: 0.7;
      }
      i {
        margin-right: 0px;
        font-size: 12px;
        transform: scale(0.85);
      }
    }
    .red-bgd {
      background: $red;
      color: white;
    }
    .selected {
      border-color: $blue;
      color: $blue;
    }
  }
  .left {
    display: flex;
    align-items: center;
    .img {
      border-radius: 100%;
      width: 35px;
      height: 35px;
      background-position: center;
      background-color: #eee;
      background-size: cover;
      margin: 0 5px 0 0;
    }
  }
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transition: all 0.3s;
  transform: translateY(30px);
}

.list-leave-active {
  position: absolute;
}

.shadow {
  // box-shadow: $deep-shadow;
  border-bottom: 1px solid #eee;
}

.faq-link {
  text-align: center;
  width: 90%;
  margin: 5px auto 5px auto;
  background: #f7f7f7;
  border-radius: 5px;
  font-size: 13px;
  padding: 10px 0;
  font-weight: bold;
  transition: 0.1s;
  &:active {
    transform: scale(0.95);
  }
}
.promo-bar {
  text-align: center;
  color: $homeclass-promo-light-orange;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $homeclass-promo-dark;
  width: 90%;
  margin: 15px auto 0 auto;
  border-radius: 5px;
  height: 50px;
  font-size: 15px;
  font-weight: 500;
  animation-duration: 0.5s !important;
  transition: all 0.1s;
  &:active {
    opacity: 0.7;
  }
  i {
    font-size: 20px;
    margin-right: 5px;
  }
}

.content-wrapper {
  transition: all 0.3s;
  padding-bottom: 70px;
}

#noticeboard {
  background: white;
  width: 100%;
  padding-top: 53px;
  min-height: 100vh;
  .empty {
    height: 60vh;
    width: 90%;
    margin: auto;
    h1 {
      font-weight: bold;
      font-size: 25px;
      margin-bottom: 10px;
    }
    h2 {
      font-size: 15px;
      font-weight: 300;
      line-height: 1.3;
      span {
        font-weight: 400;
        color: $red;
      }
    }
  }
}

#homeclass-list {
  transition: all 0.5s;
}

#homeclass-my {
  background: white;
}

.box-wrapper {
  background: white;
  min-height: 100vh;
  width: 100%;
  margin: auto;
  padding: 0 5%;

  .big {
    p {
      margin-left: 0;
    }
    i {
      font-size: 25px;
      left: 0;
      color: $box-color;
    }
  }
}

.box {
  background: white;
  border-bottom: 1px solid #ececec;
  border-radius: 0;
  padding: 17px 0;
  margin: 0;
  i {
    color: $grey;
    right: 0;
    display: none;
  }
  p {
    font-size: 15px;
  }
  &:hover {
    background: white;
  }
}

.links .text-container {
  border: none;
  margin: 15px 0;
  margin-top: 50px;
  h1 {
    font-size: 17px;
    color: $black;
    font-weight: 500;
    padding: 0;
  }
}
</style>
<script>
import InlineLoading from "vux/src/components/inline-loading"
import Item from "../homelesson/Item"
import SelectArea from "../homelesson/Area"
import footerBox from "../public/footer"
import User from "@/components/my/User"

export default {
  name: "Noticeboard",
  components: {
    InlineLoading,
    Item,
    SelectArea,
    footerBox,
    User,
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  data() {
    return {
      // 地区
      selectedArea: 0,
      areas: {
        0: "全国",
        3: "深圳",
        2: "厦门",
        1: "泉州",
        7: "福州",
      },
      // 组件管理
      isShowArea: false,
      isShowMyClasses: false,
      // 全新拼课功能
      homeclass: [],
      myHomeclass: [],
      isPost: "",
      questions: "",
      // 时区
      currentTimezone: "",
      // 滚动
      scrollPostionPrimary: 0,
      scrollPostionSecondary: 0,
      // 新人拼课
      isPromoAvailability: false,
      promo: "",
      // 没有课程状态
      noHomeclass: 0,
      noMyHomeclass: 0,
      components: {
        user: false,
      },
    }
  },
  created() {
    this.getHomeclass()
    this.getMyHomeclass()
    this.wechatInit()
    this.bindScroll()
  },
  beforeDestroy() {
    document.onscroll = null
  },
  methods: {
    tab() {
      if (!this.isShowMyClasses) {
        this.scrollPostionPrimary = window.scrollY
        this.isShowMyClasses = true
        setTimeout(() => window.scrollTo(0, this.scrollPostionSecondary), 0)
        document.title = "我的拼课 — AnyTeach"
      } else {
        this.scrollPostionSecondary = window.scrollY
        this.isShowMyClasses = false
        setTimeout(() => window.scrollTo(0, this.scrollPostionPrimary), 0)
        document.title = "同城拼课 — AnyTeach"
      }
    },
    onChangeArea(area_id) {
      this.selectedArea = area_id
      this.isShowArea = false
      setTimeout(() => window.scrollTo(0, 0), 0)
    },
    getDatetime(item) {
      let datetimeString = ""
      for (let i = 0; i < 3; i++) {
        let date = new Date(item.date[i])
        datetimeString += `${date.getMonth() + 1} 月 ${date.getDate()} 日 ${item.datetime[i]}`
        if (i != 2) datetimeString += "、"
      }
      return datetimeString
    },
    postClass() {
      this.$router.push({ name: "PostHomelesson" })
    },
    getHomeclass() {
      this.$axios({
        url: window.PHP_ROOT + "/index/collage/bulletinBoard",
        method: "POST",
      })
        .then(({ data }) => {
          const { code, msg } = data
          if (code != 1000 || !msg[0]) {
            this.noHomeclass++
          } else {
            this.noHomeclass = 0
            msg.forEach(item => {
              item.homeclassType = 2
              item.area = item.area_id
              item.timeslot = JSON.parse(item.timeslot)
              item.openingDate = bus.getDateObj(
                new Date(item.date[0]),
                item.time[0],
                bus.incrementTime(item.time[0], item.duration),
              )
              item.spots = item.pax == 1 ? 1 - item.sub_user.length : 7 - item.sub_user.length
            })
            this.homeclass.push(...msg)
          }
          this.getOldHomeclass()
        })
        .catch(error => {
          this.getOldHomeclass()
          this.noHomeclass++
        })
    },
    getOldHomeclass() {
      this.$axios({
        url: window.PHP_ROOT + "/index/homeclass/bulletin_board",
        method: "POST",
      })
        .then(({ data }) => {
          const { code, msg } = data
          if (code == 1000) {
            this.noHomeclass = 0
            msg.forEach(item => {
              item.homeclassType = 1
              item.promoClassTime = item.type == 1 ? this.getDatetime(item) : ""
            })
            this.homeclass.push(...msg)
          } else {
            this.noHomeclass++
          }
        })
        .catch(error => {
          this.noHomeclass++
          this.$toast("网络失败，请稍后重试")
        })
    },
    getMyHomeclass() {
      this.$axios({
        url: window.PHP_ROOT + "/index/homeclass/my_release",
        method: "POST",
      })
        .then(({ data }) => {
          const { code, msg } = data
          if (code == 1000) {
            msg.forEach(item => {
              item.homeclassType = 1
              item.promoClassTime = item.type == 1 ? this.getDatetime(item) : ""
            })
            this.myHomeclass.push(...msg)
            this.sortMyHomeclass()
          } else {
            this.noMyHomeclass++
          }
        })
        .catch(error => {
          this.noMyHomeclass++
        })

      this.$axios({
        url: window.PHP_ROOT + "/index/homeclass/my_join",
        method: "POST",
      })
        .then(({ data }) => {
          const { code, msg } = data
          if (code == 1000) {
            msg.forEach(item => {
              item.homeclassType = 1
              item.promoClassTime = item.type == 1 ? this.getDatetime(item) : ""
            })
            this.myHomeclass.push(...msg)
            this.sortMyHomeclass()
          } else {
            this.noMyHomeclass++
          }
        })
        .catch(error => {
          this.noMyHomeclass++
        })

      this.$axios({
        url: window.PHP_ROOT + "/index/collage/myCollage",
        method: "POST",
      })
        .then(({ data }) => {
          const { code, msg } = data
          if (code != 1000 || !msg) {
            this.noMyHomeclass++
          } else {
            msg.forEach(item => {
              item.homeclassType = 2
              item.timeslot = JSON.parse(item.timeslot)
              item.openingDate = bus.getDateObj(
                new Date(item.date[0]),
                item.time[0],
                bus.incrementTime(item.time[0], item.duration),
              )
              item.spots = item.pax == 1 ? 1 - item.sub_user.length : 7 - item.sub_user.length
            })
            this.myHomeclass.push(...msg)
            this.sortMyHomeclass()
          }
        })
        .catch(error => {
          this.noMyHomeclass++
        })
    },
    sortMyHomeclass() {
      this.myHomeclass.sort((a, b) => {
        let d1 = new Date(a.create_time)
        let d2 = new Date(b.create_time)
        return d2.getTime() - d1.getTime()
      })
    },
    // 跳转 FAQ 页面
    detailsArticle(item) {
      if (item == 99) {
        item = {
          id: 99,
          title: "价格查询",
        }
      }
      this.$router.push({
        name: "faq",
        params: {
          faq_id: item.id,
        },
      })
    },
    wechatInit() {
      wx.ready(() => {
        bus.wxShareConfig({
          type: "all",
          url: "/#/homeclass",
          name: window.document.title,
          desc: "和同城市的小伙伴一起在家拼课，邀请首单用户立减学费。",
        })
      })
    },
    bindScroll() {
      document.onscroll = () => {
        if (typeof (document.getElementsByClassName("nav")[0]) !== "undefined") {
          if (window.scrollY > 53) {
            document.getElementsByClassName("nav")[0].classList.add("shadow")
          } else {
            document.getElementsByClassName("nav")[0].classList.remove("shadow")
          }
        }
      }
    },
  },
}
</script>
